//import "whatwg-fetch";
//import { fetch as fetchPolyfill } from "whatwg-fetch";
import { Translation as Tr } from "./Translation.js";

var HodnoceniObchodu = {
  defaultOpt: {
    max: 4
  },
  opt: {},

  ziskejHodnoceni: function(opt) {
    Lc.f("ziskejHodnoceni");
    this.opt = _.extend(this.defaultOpt, opt);

    //const url = window.location.origin + "/hodnoceni-obchodu/?ldzFetch";
    //const url = window.location.origin + "/en/savle/?ldzFetch";
    //const url = window.location.origin + "/en/store-rating/?ldzFetch";
    let url =
      window.location.origin + Tr.l("url_hodnoceni_obchodu") + "?ldzFetch";

    return fetch(url)
      .then(function(response) {
        return response.text();
      })
      .then(function(data) {
        //elem.innerHTML = string;
        return HodnoceniObchodu.prms_getContainer(data);
      })
      .catch(error => {
        Lc.ctch(error);
      });
  },
  prms_getContainer: function(html) {
    return new Promise(function(resolve) {
      Lc.promise("Promise html");
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");

      let tt = doc.querySelector(".votes-wrap");
      let prispevky = $(tt);
      Lc.log(tt);

      let $kod = '<div class="votes-wrap">';
      let $x = 0;
      prispevky.find(".vote-wrap").each(function() {
        $x++;
        var tento = $(this);
        let $k = $("<div />")
          .append(tento.eq(0).clone())
          .html();
        $kod += $k;
        if ($x > 3) return false;
      });

      $kod += "</div>";
      return resolve($kod);
    });
  },

  _init: function() {}
};

HodnoceniObchodu._init();

export { HodnoceniObchodu };
